export const getRegion = (state) => state.app.region;
export const getCurrency = (state) => state.app.currency;
export const getToast = (state) => state.app.toast;
